
import { GoogleGenAI } from "@google/genai";
import { RockAnalysis } from "../../types";

/**
 * 知识提炼助手 (Knowledge Distiller)
 * 目标：将专家的纠偏意见转化为标准化的 Case Rules，用于更新 core_v5_frozen.ts
 */
export const distillCaseRule = async (
  originalAnalysis: RockAnalysis,
  correctName: string,
  expertReason: string,
  imageBase64: string
): Promise<string> => {
  const apiKey = process.env.GEMINI_API_KEY || process.env.API_KEY;
  if (!apiKey) {
    throw new Error("API Key is missing. Please set GEMINI_API_KEY in settings.");
  }
  const ai = new GoogleGenAI({ apiKey });
  
  const prompt = `
    你是一位地质学知识工程专家。
    
    [输入信息]
    - AI 原始鉴定: ${originalAnalysis.name}
    - 专家修正名称: ${correctName}
    - 专家修正理由: ${expertReason}
    - 岩石特征数据: ${JSON.stringify(originalAnalysis)}
    
    [任务]
    请根据以上信息，提炼出一条简洁、专业、具有排他性的“鉴定准则 (Case Rule)”。
    这条准则应该能帮助 AI 在未来区分这两种容易混淆的岩石。
    
    [输出格式示例]
    - **[岩石A] vs [岩石B]**: [关键视觉/结构差异判据]。
    
    请直接输出准则文本，不要包含其他解释。
  `;

  const response = await ai.models.generateContent({
    model: "gemini-3-flash-preview",
    contents: {
      parts: [
        { text: prompt },
        { inlineData: { mimeType: "image/jpeg", data: imageBase64.split(',')[1] } }
      ]
    }
  });

  return response.text || "未能提炼出有效准则。";
};
